import { type FC } from 'react';

import {
  type LotteryTicketType,
  type TicketRewardType,
} from '@/common/types/lottery';

import { Picture } from '../Picture/Picture';

import diamondPng from '/img/lottery/diamond.png';
import diamondWebp from '/img/lottery/diamond.webp';
import goldPng from '/img/lottery/gold.png';
import goldWebp from '/img/lottery/gold.webp';
import silverPng from '/img/lottery/silver.png';
import silverWebp from '/img/lottery/silver.webp';

interface Ticket3DPictureProps {
  kind: LotteryTicketType | TicketRewardType;
  className?: string;
}

const Ticket3DPicture: FC<Ticket3DPictureProps> = ({ kind, className }) => {
  const images: Record<
    LotteryTicketType | TicketRewardType,
    { img: string; webp?: string }
  > = {
    Silver: {
      img: silverPng,
      webp: silverWebp,
    },
    silverTicket: {
      img: silverPng,
      webp: silverWebp,
    },
    Gold: {
      img: goldPng,
      webp: goldWebp,
    },
    goldTicket: {
      img: goldPng,
      webp: goldWebp,
    },
    Diamond: {
      img: diamondPng,
      webp: diamondWebp,
    },
    diamondTicket: {
      img: diamondPng,
      webp: diamondWebp,
    },
  };

  return <Picture {...images[kind]} className={className} alt={kind} />;
};

export { Ticket3DPicture };
